import React, { useEffect, useState } from 'react';
import { designFor, photoSourceLabel } from './product-designs.js';
import './product-photos.css';

export default function ProductPhoto({ product, loading = 'lazy' }) {
  const design = designFor(product);
  const [index, setIndex] = useState(0);
  useEffect(() => setIndex(0), [product.slug]);
  const candidate = design.photoCandidates[Math.min(index, design.photoCandidates.length - 1)];
  const label = photoSourceLabel(candidate.photoSource, design.view);
  return <>
    <img src={candidate.photo} alt={`${product.name} — ${label}`} loading={loading}
      data-photo-source={candidate.photoSource} data-print-view={design.view}
      onError={() => setIndex(i => Math.min(i + 1, design.photoCandidates.length - 1))}/>
    <span className="product-photo-status" data-source={candidate.photoSource}>{label}</span>
  </>;
}
